import React from "react";

export const QuestionStageHeader = ({
  stage,
  onAddQuestion,
  passage = false,
}) => {
  return (
    <div className="text-md text-orange-600 gap-x-2 mb-2 flex justify-start items-center">
      {stage === 1
        ? passage
          ? "Preliminary English Aptitude Test "
          : "Preliminary Assessment Test"
        : "Second Round of Assessment"}
      <button
        type="button"
        onClick={() => onAddQuestion(stage, passage)}
        className="ml-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      </button>
    </div>
  );
};
